export const getTranslatedText = (translatedText?: string, originalText?: string) => {
  if (!translatedText || translatedText === '0') {
    return originalText || ""
  }
  return translatedText
}